import generateAction from '@piconetworks/pkg-generate-action';

var getUrlMetadata = generateAction({
  baseActionCreatorName: 'getUrlMetadata',
  baseActionTypeName: 'GET_URL_METADATA'
});
var getUrlsMetadata = generateAction({
  baseActionCreatorName: 'getUrlsMetadata',
  baseActionTypeName: 'GET_URLS_METADATA'
});
var types = [].concat(getUrlMetadata.types, getUrlsMetadata.types, ['CLEAR_CURRENT_URL']);
var creators = function creators(duck) {
  return Object.assign({}, getUrlMetadata.creators(duck), getUrlsMetadata.creators(duck), {
    clearCurrentUrl: function clearCurrentUrl() {
      return {
        type: duck.types.CLEAR_CURRENT_URL
      };
    }
  });
};

export { creators, types };
//# sourceMappingURL=actions.js.map
